import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TestimonialsAndGameModes: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center p-16 sm:p-8 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
      <div className="flex items-start flex-row md:flex-col w-full max-w-7xl gap-12 md:gap-12">
        {/* Left: Testimonials */}
        <div className="flex-1 w-full">
          <h2 className="text-tertiary font-bold font-IBMPlex text-4xl sm:text-3xl md:text-5xl mb-8">
            {t.testimonials.title}
          </h2>
          <div className="space-y-6">
            {t.testimonials.items.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start gap-3">
                  <span className="text-3xl">{testimonial.emoji}</span>
                  <div className="flex-1">
                    <p className="text-tertiary font-IBMPlex text-lg sm:text-base mb-2">
                      "{testimonial.text}"
                    </p>
                    <p className="text-tertiary/70 font-IBMPlex text-sm font-medium">
                      — {testimonial.author}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Right: Game Modes */}
        <div className="flex-1 w-full">
          <h2 className="text-tertiary font-bold font-IBMPlex text-4xl sm:text-3xl md:text-5xl mb-8">
            {t.gameModes.title}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {t.gameModes.modes.map((mode, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-purple-500 via-pink-500 to-blue-500 p-6 rounded-xl text-white shadow-lg hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer"
              >
                <div className="flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-4xl">{mode.emoji}</span>
                    <h3 className="font-bold font-IBMPlex text-xl sm:text-lg">
                      {mode.name}
                    </h3>
                  </div>
                  <p className="text-white/90 font-IBMPlex text-sm sm:text-xs">
                    {mode.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsAndGameModes;
